// Mock data for monetization tab
export const mockMonetizationData = {
    // Top KPIs data
    totalAdvancesCount: 130560,
    totalAdvancesCountPercentage: 20,
    advancesFees: 391680,
    advancesFeesPercentage: 20,
    directDepositSwitchVolume: 342720000,
    directDepositSwitchVolumePercentage: 20,
    settlementsValue: 59500,
    settlementsValuePercentage: 20,
    
    // Bottom KPIs data
    avgRevenuePerAdvance: 2.95,
    avgRevenuePerAdvancePercentage: 20,
    avgRevenuePerUser: 15.98,
    avgRevenuePerUserPercentage: 20,
    avgDirectDepositPerNewUser: 42000,
    avgDirectDepositPerNewUserPercentage: 20,
    avgNetInterestIncomePerNewUser: 7.29,
    avgNetInterestIncomePerNewUserPercentage: 20
};

export const monetizationConfig = {
    title: "Monetization KPIs",
    topKPIs: [
        {
            key: 'totalAdvancesCount',
            title: 'Total Advances',
            percentageKey: 'totalAdvancesCountPercentage'
        },
        {
            key: 'advancesFees',
            title: 'Non-Interest Income ($)',
            percentageKey: 'advancesFeesPercentage',
            isCurrency: true
        },
        {
            key: 'directDepositSwitchVolume',
            title: 'Total New Direct Deposit Volume',
            percentageKey: 'directDepositSwitchVolumePercentage',
            isCurrency: true
        },
        {
            key: 'settlementsValue',
            title: 'Total Net Interest Income',
            percentageKey: 'settlementsValuePercentage',
            isCurrency: true
        }
    ],
    charts: [
        {
            title: 'Advances & Non-Interest Income',
            type: 'advancesAndNonInterestIncome'
        },
        {
            title: 'Direct Deposit Volume & Net Interest Income',
            type: 'directDepositVolumeAndNetInterestIncome'
        }
    ],
    bottomKPIs: [
        {
            key: 'avgRevenuePerAdvance',
            title: 'Avg. Revenue per Advance',
            percentageKey: 'avgRevenuePerAdvancePercentage',
            isCurrency: true
        },
        {
            key: 'avgRevenuePerUser',
            title: 'Avg. Revenue per User',
            percentageKey: 'avgRevenuePerUserPercentage',
            isCurrency: true
        },
        {
            key: 'avgDirectDepositPerNewUser',
            title: 'Avg. Direct Deposit per New User',
            percentageKey: 'avgDirectDepositPerNewUserPercentage',
            isCurrency: true
        },
        {
            key: 'avgNetInterestIncomePerNewUser',
            title: 'Avg. Net Interest Income per New User',
            percentageKey: 'avgNetInterestIncomePerNewUserPercentage',
            isCurrency: true
        }
    ]
};
